import * as React from 'react';
import { Layout, Card, Button, Modal, message } from 'antd';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { PageLoadingPlaceholder } from '../page_loading_placeholder/PageLoadingPlaceholder';
import {
	partsRequestedWorkOrderForSupplier,
	workOrdersRestCrudThunksForSupplier,
} from '../../thunks/work_orders_thunks';
import AddPartsModal from './AddPartsModal';
import AddEquipmentModal from './AddEquipmentModal';
import PurchaseRequestForm from '../purchase_request_form/PurchaseRequestForm';
import { capitalizeEachWord } from '../../utils/DataFormatterUtils';
import { getEntityById, nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { purchaseRequestsRestCrudThunksForSupplier } from '../../thunks/purchase_requests_thunks';
import { getLinkWIthBackLinkParams } from '../../utils/HistoryUtils';
import { stockLocationsRestCrudThunksForSupplier } from '../../thunks/stock_locations_thunks';
import { requestedPartsRestCrudThunksForSupplier } from '../../thunks/requested_parts_thunks';
import RequestedPartsSectionInWorkOrder from './RequestedPartsSectionInWorkOrder';
import PurchaseRequestsSectionInWorkOrder from './PurchaseRequestsSectionInWorkOrder';
import { LIMIT_ONE_PAGINATION, ROLE_TYPES } from '../../utils/DataConstants';
import EditWOPartQuantityModal from './EditWOPartQuantityModal';
import WorkOrderPartsSection from './WorkOrderPartsSection';
import {
	removeEquipmentFromWorkOrder,
	removePartFromWorkOrder,
} from '../../thunks/parts_equipments_work_orders_thunks';
import WorkOrderEquipmentSection from './WorkOrderEquipmentSection';
import WorkOrderToolsSection from './WorkOrderToolsSection';
import WOPartsTotalCost from './WOPartsTotalCost';
import UnarchivePopConfirm from '../unarchive_pop_confirm/UnarchivePopConfirm';
import SpotPurchasesSectionInWorkOrder from './SpotPurchasesSectionInWorkOrder';
import { isInternalTech } from '../../utils/AuthUtils';
import { isMoveToOnHoldDisabled } from '../../utils/WorkOrderUtils';

const { Content } = Layout;
const BACK_LINK_TEXT = 'Back to work order';

class SupplierWorkOrderDetailChargesPage extends React.Component<any, any> {
	constructor(props) {
		super(props);
		this.state = {
			addPartsModalVisible: false,
			addEquipmentsModalVisible: false,
			requestedPart: {},
			requestedEquipment: {},
			createPRVisible: false,
			loading: false,
			woStockLocationId: undefined,
			requestedPartsAvailable: false,
			requestedPartQuantityVisible: false,
			currentRequestedPart: null,
			purchaseRequestsAvailable: false,
			releaseText: '',
			woPartQuantityModalVisible: false,
			currentEditingPart: null,
			partsCostRefreshKey: 0,
			partsRefreshKey: 0,
		};
	}

	fetchWorkOrder = (): any => {
		const { getWorkOrder, match } = this.props;
		const workOrderId = match.params.id;
		return getWorkOrder(workOrderId);
	};

	checkForRequestedParts = () => {
		const { fetchRequestedParts, match } = this.props;
		const workOrderId = match.params.id;

		fetchRequestedParts({ workOrderId }, null, LIMIT_ONE_PAGINATION).then((res) =>
			this.setState({ requestedPartsAvailable: res && res.length > 0 })
		);
	};

	checkForPurchaseRequests = () => {
		const { fetchPurchaseRequestCount, match } = this.props;
		const workOrderId = match.params.id;

		fetchPurchaseRequestCount({ workOrderId }).then((res) =>
			this.setState({ purchaseRequestsAvailable: res > 0 })
		);
	};

	componentDidMount() {
		const { fetchStockLocations, workOrder } = this.props;
		if (workOrder && workOrder.id) {
			const locationId = workOrder.locationId;
			locationId &&
				fetchStockLocations({
					locationId,
				}).then((stockLocations) => {
					stockLocations &&
						stockLocations.length > 0 &&
						this.setState({ woStockLocationId: stockLocations[0].id });
				});
		} else {
			this.fetchWorkOrder().then((workOrder) => {
				const locationId = workOrder.locationId;
				locationId &&
					fetchStockLocations({
						locationId,
					}).then((stockLocations) => {
						stockLocations &&
							stockLocations.length > 0 &&
							this.setState({ woStockLocationId: stockLocations[0].id });
					});
			});
		}
		this.checkForRequestedParts();
		this.checkForPurchaseRequests();
	}

	refreshChargesPage = () => {
		this.fetchWorkOrder();
		this.checkForRequestedParts();
		this.checkForPurchaseRequests();
	};

	showAddPartsModal = () => this.setState({ addPartsModalVisible: true });

	hideAddPartsModal = () => this.setState({ addPartsModalVisible: false });

	changeStatusToPartsRequestedAndRefreshChargesPage = () => {
		const { workOrder, partsRequested, currentUser } = this.props;
		if (isMoveToOnHoldDisabled(workOrder, currentUser, null)) {
			this.refreshChargesPage();
			return;
		}
		this.setState({ loading: true });
		partsRequested(workOrder)
			.then(() => this.refreshChargesPage())
			.catch((err) => message.error('Unable to update status!', err))
			.finally(() => this.setState({ loading: false }));
	};

	addPartsSuccess = (isMobile) => {
		this.hideAddPartsModal();
		if (isMobile) {
			this.refreshChargesPage();
		} else {
			this.changeStatusToPartsRequestedAndRefreshChargesPage();
		}
	};

	showAddEquipmentsModal = () => this.setState({ addEquipmentsModalVisible: true });

	hideAddEquipmentsModal = () => this.setState({ addEquipmentsModalVisible: false });

	addEquipmentsSuccess = () => {
		this.hideAddEquipmentsModal();
		this.refreshChargesPage();
	};

	onRemovePart = (workOrderPart) => () => {
		const { match, removePartFromWO } = this.props;

		const entity = {
			workOrderId: match.params.id,
			partId: workOrderPart.partId,
			...(nullSafeGet('locationId', workOrderPart) && {
				locationId: workOrderPart.locationId,
			}),
			...(nullSafeGet('partsPerStockLocationId', workOrderPart) && {
				partsPerStockLocationId: workOrderPart.partsPerStockLocationId,
			}),
		};
		removePartFromWO(entity).then(() => this.refreshChargesPage());
	};

	hideEditPartModal = () => {
		this.setState({
			currentEditingPart: null,
			woPartQuantityModalVisible: false,
		});
	};

	onPartQuantityEditSuccess = () => {
		this.hideEditPartModal();
		this.setState((prev) => ({
			partsCostRefreshKey: prev.partsCostRefreshKey + 1,
			partsRefreshKey: prev.partsRefreshKey + 1,
		}));
	};

	editPartQuantity = (partWithServiceCall) => () => {
		this.setState({
			currentEditingPart: partWithServiceCall,
			woPartQuantityModalVisible: true,
		});
	};

	onRemoveEquipment = (equipmentInWO) => () => {
		const { removeEquipmentFromWO, match } = this.props;

		removeEquipmentFromWO({
			workOrderId: match.params.id,
			equipmentPerStockLocationId: equipmentInWO.equipmentPerStockLocationId,
		}).then(() => this.fetchWorkOrder());
	};

	onCreatePartPurchaseRequest = ({
		part,
		quantity,
		stockLocationId,
		locationId,
		disableLocation,
	}) => {
		this.hideAddPartsModal();
		const price =
			nullSafeGet('defaultPartCatalog.listPrice', part) ||
			nullSafeGet('defaultPartCatalog.lastPrice', part) ||
			nullSafeGet('cost', part);
		this.setState({
			requestedPart: {
				part,
				partId: nullSafeGet('id', part),
				partCatalog: {
					...nullSafeGetOrElse('defaultPartCatalog', part, {}),
					...(nullSafeGet('defaultPartCatalog.id', part) && {
						partEquipmentVendor: nullSafeGet('defaultVendor', part),
					}),
				},
				partCatalogId: part.defaultPartCatalogId,
				quantity: quantity || 1,
				unitCost: price || undefined,
				cost: !!price ? price * (quantity || 1) : undefined,
				stockLocationId,
				locationId,
				disableLocation,
			},
			createPRVisible: true,
		});
	};

	onCreateEquipmentPurchaseRequest = (equipmentType, stockLocationId) => {
		this.hideAddEquipmentsModal();
		const price =
			nullSafeGet('defaultEquipmentCatalog.listPrice', equipmentType) ||
			nullSafeGet('defaultEquipmentCatalog.lastPrice', equipmentType) ||
			nullSafeGet('cost', equipmentType);
		this.setState({
			requestedEquipment: {
				equipmentType,
				quantity: 1,
				equipmentTypeId: nullSafeGet('id', equipmentType),
				equipmentCatalog: {
					...nullSafeGetOrElse('defaultEquipmentCatalog', equipmentType, {}),
					...(nullSafeGet('defaultEquipmentCatalog.id', equipmentType) && {
						partEquipmentVendor: nullSafeGet('defaultVendor', equipmentType),
					}),
				},
				equipmentCatalogId: equipmentType.defaultEquipmentCatalogId,
				unitCost: price || undefined,
				cost: price || undefined,
				stockLocationId,
			},
			createPRVisible: true,
		});
	};

	getPRTitlePrefix = () => {
		const { requestedPart, requestedEquipment } = this.state;
		const partNumber = nullSafeGet('part.partNumber', requestedPart)
			? `#${nullSafeGetOrElse('part.partNumber', requestedPart, '')} - `
			: '';
		const partName = nullSafeGet('part.name', requestedPart)
			? `'${nullSafeGetOrElse('part.name', requestedPart, '')}'`
			: '';
		const equipmentNumber = nullSafeGet(`equipmentType.equipmentTypeNumber`, requestedEquipment)
			? `#${nullSafeGet(`equipmentType.equipmentTypeNumber`, requestedEquipment)} - `
			: '';
		const equipmentName = nullSafeGet('equipmentType.modelName', requestedEquipment)
			? `'${nullSafeGetOrElse('equipmentType.modelName', requestedEquipment, '')}'`
			: '';
		return nullSafeGet('partId', requestedPart)
			? `Part ${partNumber} ${partName}`
			: `Equipment ${equipmentNumber} ${equipmentName}`;
	};

	hideCreatePRModal = () =>
		this.setState({
			createPRVisible: false,
			requestedPart: {},
			requestedEquipment: {},
		});

	onCreatePurchaseRequestSuccess = (record) => {
		const { workOrder, partsRequested, currentUser } = this.props;
		if (isMoveToOnHoldDisabled(workOrder, currentUser, null)) {
			this.refreshChargesPage();
			this.hideCreatePRModal();
			return;
		}
		this.setState({ loading: true });
		partsRequested(workOrder)
			.then((values) => this.refreshChargesPage())
			.catch(message.error)
			.finally(() => this.setState({ loading: false }));
		this.hideCreatePRModal();
	};

	onPartOrEquipmentRow = (urlPrefix) => (record) => ({
		onClick: () => {
			const { history, location } = this.props;
			const path = `/supplier/${urlPrefix}/detail/${record.id}/details`;
			history.push(getLinkWIthBackLinkParams(location, BACK_LINK_TEXT, path));
		},
	});

	getTechnicianName = () => {
		const { currentUser } = this.props;
		return currentUser.nameGiven && currentUser.nameFamily
			? capitalizeEachWord([currentUser.nameGiven, currentUser.nameFamily].join(' '))
			: '';
	};

	getPRName = () => {
		const { workOrder } = this.props;
		const prefix = this.getPRTitlePrefix();

		return `${prefix} requested by ${this.getTechnicianName()} for work order : #${workOrder.id}`;
	};

	render() {
		const { workOrder, workOrdersFetching, currentUser, companyConfig } = this.props;

		const defaultServiceCall = workOrder.lastServiceCall;
		const spotPurchasesEnabled = nullSafeGetOrElse(
			'config.spotPurchasesConfig.enableSpotPurchases',
			companyConfig,
			false
		);
		const showSpotPurchases = isInternalTech(currentUser) && spotPurchasesEnabled;

		const showPageLoader =
			this.state.loading || (workOrdersFetching && !nullSafeGet('id', workOrder));

		return showPageLoader ? (
			<PageLoadingPlaceholder />
		) : (
			<Content
				className="supplierWorkOrderDetailChargesPagePage"
				style={{
					padding: '0 0.5em',
				}}
			>
				<div>
					{showSpotPurchases ? (
						<div className="rowSpacing">
							<SpotPurchasesSectionInWorkOrder
								workOrder={workOrder}
								userType={ROLE_TYPES.SUPPLIER}
							/>
						</div>
					) : null}
					{this.state.purchaseRequestsAvailable && (
						<div className="rowSpacing">
							<PurchaseRequestsSectionInWorkOrder />
						</div>
					)}
					{this.state.requestedPartsAvailable && (
						<div className="rowSpacing">
							<RequestedPartsSectionInWorkOrder
								key={this.state.partsRefreshKey}
								onRefresh={this.refreshChargesPage}
							/>
						</div>
					)}
					<div className="rowSpacing">
						<Card
							title={`Parts`}
							extra={
								<div className="flex flex-row items-center">
									<WOPartsTotalCost key={this.state.partsCostRefreshKey} />
									<UnarchivePopConfirm onClick={this.showAddPartsModal} isClientView={true}>
										<Button>Add parts</Button>
									</UnarchivePopConfirm>
								</div>
							}
						>
							<WorkOrderPartsSection
								key={this.state.partsRefreshKey}
								workOrder={workOrder}
								editPartQuantity={this.editPartQuantity}
								onRemovePart={this.onRemovePart}
								showQuantity
							/>
						</Card>
					</div>
					<div className="rowSpacing">
						<Card
							title={`Equipment`}
							extra={
								<UnarchivePopConfirm onClick={this.showAddEquipmentsModal} isClientView={true}>
									<Button>Add equipment</Button>
								</UnarchivePopConfirm>
							}
						>
							<WorkOrderEquipmentSection
								workOrder={workOrder}
								onRemoveEquipment={this.onRemoveEquipment}
							/>
						</Card>
					</div>
					<div className="rowSpacing">
						<WorkOrderToolsSection workOrder={workOrder} />
					</div>
				</div>
				{this.state.addPartsModalVisible && (
					<AddPartsModal
						serviceCall={defaultServiceCall}
						woStockLocationId={this.state.woStockLocationId}
						onCancel={this.hideAddPartsModal}
						successCallback={this.addPartsSuccess}
						openCreatePurchaseRequest={this.onCreatePartPurchaseRequest}
					/>
				)}
				{this.state.addEquipmentsModalVisible && (
					<AddEquipmentModal
						serviceCall={defaultServiceCall}
						woStockLocationId={this.state.woStockLocationId}
						onCancel={this.hideAddEquipmentsModal}
						successCallback={this.addEquipmentsSuccess}
						openCreatePurchaseRequest={this.onCreateEquipmentPurchaseRequest}
					/>
				)}
				{this.state.createPRVisible && (
					<Modal
						visible={this.state.createPRVisible}
						closable
						width="95%"
						title="Create Purchase Request"
						onCancel={this.hideCreatePRModal}
						footer={null}
					>
						<div>
							<h5 style={{ marginBottom: 24 }}>New Purchase Request</h5>
							<PurchaseRequestForm
								isModal
								formData={{
									name: this.getPRName(),
									workOrder,
									workOrderId: workOrder.id,
									...(workOrder.isWarranty &&
										workOrder.assetId && { warrantyAssetId: workOrder.assetId }),
									description: `${this.getPRTitlePrefix()} requested in work order #${
										workOrder.id
									} (${workOrder.title}). Requested by ${this.getTechnicianName()}`,
									stockLocationId: nullSafeGet('state.requestedPart.stockLocationId', this),
									locationId: nullSafeGet('state.requestedPart.locationId', this),
									disableLocation: nullSafeGetOrElse(
										'state.requestedPart.disableLocation',
										this,
										false
									),
								}}
								requestedParts={
									nullSafeGet('state.requestedPart.partId', this) ? [this.state.requestedPart] : []
								}
								requestedEquipments={
									nullSafeGet('state.requestedEquipment.equipmentTypeId', this)
										? [this.state.requestedEquipment]
										: []
								}
								onSuccess={this.onCreatePurchaseRequestSuccess}
							/>
						</div>
					</Modal>
				)}
				{this.state.woPartQuantityModalVisible ? (
					<EditWOPartQuantityModal
						workOrderPart={this.state.currentEditingPart}
						onSuccess={this.onPartQuantityEditSuccess}
						onCancel={this.hideEditPartModal}
					/>
				) : null}
			</Content>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	workOrdersFetching: state.work_orders.fetching,
	workOrder: getEntityById(ownProps.match.params.id, state.work_orders),
	currentUser: state.session.currentUser,
	match: ownProps.match,
	history: ownProps.history,
	location: ownProps.location,
	companyConfig: state.company_config.detail,
});

const mapDispatchToProps = (dispatch) => ({
	getWorkOrder: (id) => dispatch(workOrdersRestCrudThunksForSupplier.readOne(id)),
	removePartFromWO: (partData) => dispatch(removePartFromWorkOrder(ROLE_TYPES.SUPPLIER)(partData)),
	removeEquipmentFromWO: (equipmentData) =>
		dispatch(removeEquipmentFromWorkOrder(ROLE_TYPES.SUPPLIER)(equipmentData)),
	updateWorkOrderPartially: (id, entity) =>
		dispatch(workOrdersRestCrudThunksForSupplier.updatePartially(id, entity)),
	fetchPurchaseRequestCount: (params) =>
		dispatch(purchaseRequestsRestCrudThunksForSupplier.countBy(params, 'prCount')),
	partsRequested: (workOrder) => dispatch(partsRequestedWorkOrderForSupplier(workOrder)),
	fetchStockLocations: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			stockLocationsRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchRequestedParts: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			requestedPartsRestCrudThunksForSupplier.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(SupplierWorkOrderDetailChargesPage)
);
